import { AdobeData, EventQueueInterface } from './types';

export default class EventQueue implements EventQueueInterface {
  private isSink = false;

  private queue: AdobeData[] = [];

  public get length(): number {
    return this.queue.length;
  }

  public push(event: AdobeData): number {
    if (this.isSink) {
      return 0;
    }
    return this.queue.push(event);
  }

  public getState() {
    return this.isSink ? 'no-op' : ('initializing' as any);
  }

  public setEmpty(): void {
    this.queue.length = 0;
  }

  public shift() {
    if (this.isSink) {
      return undefined;
    }
    return this.queue.shift();
  }

  public convertToSink(): void {
    this.setEmpty();
    this.isSink = true;
  }
}
